import { motion, useTransform } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const SpinBadge = () => (
  <div className="absolute -left-6 sm:-left-10 bottom-10 w-28 h-28 sm:w-36 sm:h-36 rounded-full bg-cream shadow-xl flex items-center justify-center" style={{ transform: "translateZ(60px)" }}>
    <svg viewBox="0 0 100 100" className="w-full h-full animate-[spin_22s_linear_infinite]">
      <defs><path id="circ" d="M50,50 m-37,0 a37,37 0 1,1 74,0 a37,37 0 1,1 -74,0" /></defs>
      <text fontSize="9" letterSpacing="2" fill="#3E5C49" fontFamily="Plus Jakarta Sans" fontWeight="600">
        <textPath href="#circ">ESCUTA · ACOLHIMENTO · CUIDADO ·</textPath>
      </text>
    </svg>
    <span className="absolute font-display italic text-2xl sm:text-3xl text-clay">TCC</span>
  </div>
);

export const HeroVisual = ({ rx, ry, progress }) => {
  const imgY = useTransform(progress, [0, 1], ["0%", "18%"]);
  return (
    <div className="lg:col-span-5 relative" style={{ perspective: 1200 }}>
      <motion.div style={{ rotateX: rx, rotateY: ry }}
        className="relative mx-auto w-[82%] sm:w-[70%] lg:w-full max-w-md">
        <motion.div data-testid="hero-image" className="relative aspect-[4/5] overflow-hidden rounded-t-full rounded-b-[2rem] bg-mint"
          initial={{ y: 60, opacity: 0.001 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 1.4, delay: 0.5, ease }}>
          <motion.div style={{ y: imgY }} className="absolute -inset-y-[12%] inset-x-0">
            <img src="/img/ana.webp" alt="Ana Falaschi, psicóloga" className="w-full h-full object-cover object-[50%_30%]" />
          </motion.div>
          <div className="absolute inset-0 bg-gradient-to-t from-ink/35 via-transparent to-transparent" />
        </motion.div>
      </motion.div>
      <motion.div initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 1.3, duration: 0.9, ease }}>
        <SpinBadge />
      </motion.div>
      <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 1.5, duration: 0.9, ease }}
        className="absolute right-0 sm:right-4 top-10 rounded-2xl bg-cream/90 backdrop-blur-md border border-sage/15 px-4 py-3 shadow-lg max-w-[190px]">
        <p className="text-[11px] uppercase tracking-[0.2em] text-clay font-semibold">De onde você estiver</p>
        <p className="font-display text-lg text-ink leading-tight mt-1">Sessões por videochamada</p>
      </motion.div>
    </div>
  );
};
